import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import ReportNote from '../../../components/ReportNote';
import ReportCard from '../../../components/ReportCard';

const MatchupReportCoachNote = ({ hasCoachNote, isLHP, batterId, hasCoachNoteCallback, showSpanish, doesHaveSpanishNoteCallback }) => {
    const { t: translate } = useTranslation();
    const doesHaveSpanishNote = (data) => {
        if (doesHaveSpanishNoteCallback) {
            doesHaveSpanishNoteCallback(data);
        }
    };

    if (hasCoachNote) {
        return (
            <ReportCard title={translate('sections.opponent.player.coach-notes')}>
                <ReportNote type="htav" section={isLHP ? 22 : 21} playerId={batterId} hasDataCallback={hasCoachNoteCallback} showSpanish={showSpanish} doesHaveSpanishDataCallback={doesHaveSpanishNote} />
            </ReportCard>
        );
    }

    return <></>;
};

MatchupReportCoachNote.propTypes = {
    hasCoachNote: PropTypes.bool.isRequired,
    isLHP: PropTypes.bool.isRequired,
    batterId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    hasCoachNoteCallback: PropTypes.func.isRequired,
    showSpanish: PropTypes.bool,
    doesHaveSpanishNoteCallback: PropTypes.func,
};
MatchupReportCoachNote.defaultProps = {
    showSpanish: false,
    doesHaveSpanishNoteCallback: undefined,
};

export default MatchupReportCoachNote;
